import { AxiosError } from 'axios'
import { ResponseObject } from './types'

export type ErrorMessage = {
    displayError: string
    logError: string
}

export function getErrorMessage(error: AxiosError<ResponseObject>, fallbackMessage: string): ErrorMessage {
    const displayError = error.response?.data?.message ?? fallbackMessage
    return { displayError: displayError, logError: `${displayError}: ${JSON.stringify(error)}` }
}
